import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface ICheckWorkFlowQueueRequest extends IBaseRequest {
    limit?:     string;
    offset?:    string;
}

export class CheckWorkFlowQueueRequest extends BaseRequest implements ICheckWorkFlowQueueRequest {
    public limit?: string;
    public offset?: string;
    constructor(server: string, session: string, limit?: string, offset?: string) {
        super(server, session);
        this.limit = limit;
        this.offset = offset;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        
        return super.wrapperXml('CheckWorkFlowQueue', parameters);
    }
}
